import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { appVersion } from '@bedrock-rdk/utils';
import { getInitialStyle } from './deviceInfoBar.style';
import connect from './deviceInfoBar.connector';

export default class DeviceInfoBar extends Lightning.Component {
  static _template() {
    return _merge(
      {
        DeviceVersion: {
          text: {},
        },
        AppVersion: {
          text: {},
        },
      },
      getInitialStyle(),
    );
  }

  set deviceVersion(value) {
    this._deviceVersion = value;
    this.setDeviceVersion();
  }

  set deviceBrand(value) {
    this._deviceBrand = value;
    this.setDeviceVersion();
  }

  set deviceModel(value) {
    this._deviceModel = value;
    this.setDeviceVersion();
  }

  setDeviceVersion() {
    const view = this.tag('DeviceVersion');

    try {
      const matches = navigator.userAgent.match(/MN=([a-zA-Z0-9]*);/);
      const userAgentModel = (matches && matches[1]) || '';
      const deviceModel = this._deviceModel || userAgentModel;
      const deviceVersion = this._deviceVersion || [this._deviceBrand, deviceModel].filter(Boolean).join(' ');
      view.text.text = `Device: ${deviceVersion}`;
    } catch (error) {
      view.text.text = '';
    }
  }

  _attach() {
    this._unsubscribe = connect(this);
    this.tag('AppVersion').text.text = `App: ${appVersion}`;
  }

  _detach() {
    if (this._unsubscribe) {
      this._unsubscribe();
      this._unsubscribe = null;
    }
  }
}
